import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";

function Landing(darkMode) {
  return (
    <DashboardLayout>
      <MDBox py={3}>
        <MDBox mt={4.5}>
          <Grid container spacing={3} pt={3} pl={4} pr={3}>
            <section className="about">
              <MDTypography variant="h2" color={darkMode ? "dark" : "white"} >
                Obsyra
              </MDTypography>
              <MDTypography fontWeight="regular" color={darkMode ? "dark" : "white"} >
              On this page, you'll find a diverse collection of tools focused on frontend development. From QR code generators and procedural generation systems to utilities for creating random strings and other useful functions to speed up your workflow. Our goal is to provide practical, agile, and customizable resources that enable you to experiment, create, and optimize your web projects efficiently.
              </MDTypography>
            </section>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Landing;
